/**
 * Step types that send something to the lead. The web twin of `SEND_STEP_TYPES` in
 * `apps/api/src/schedule/constants.ts`; keep the two lists equal.
 */
export const SEND_STEP_TYPES = [
	"emailNode",
	"linkedinInviteNode",
	"linkedinNode",
	"linkedinInmailNode",
] as const;

/** A manual message or email written in the Outbox composer: a send with `stepType` NULL. */
export const MANUAL_FOLLOW_UP_STEP_ID = "n99";

export interface SendStepLike {
	stepType?: string | null;
	stepId?: string | null;
}

/**
 * Whether a schedule row is a send. Mirrors the API's `isSendStep` / `buildIsSendStepCondition`
 * (`apps/api/src/schedule/utils/send-step.predicate.ts`), which the Outbox's server-side tabs use.
 *
 * A processed condition, starter or profile-visit node sends nothing. Counting one as a step made
 * the Outbox card read "1 of 2 sent" and "Completed" for a lead whose sequence had only evaluated
 * its first condition, and "Step 2 of 7" for a campaign with two messages on any path (PREC-4157).
 */
export const isSendStep = (row: SendStepLike): boolean =>
	(!!row.stepType && (SEND_STEP_TYPES as readonly string[]).includes(row.stepType)) ||
	row.stepId === MANUAL_FOLLOW_UP_STEP_ID;
